<template>
  <div class="myBox" :class="{'car-active':item.id==num}" @click="changeSelect" >
    <div class="banner">直降{{(item.oldAmount-item.amount)/100}}元</div>
    <div class="content">
      <div>{{item.period}}</div>
      <div style="margin-top: 7px;margin-bottom: 7px">
        <span class="spa">¥</span>
        <span class="title">{{item.amount/100}}</span>
        <span><del> ¥{{item.oldAmount/100}}  </del></span>
      </div>
      <div>立减{{(item.oldAmount-item.amount)/100}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayBill',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  props: {
    myName: {
      type: Object
    },
    myIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tableData: [],
      item: {},
      num: 1
    }
  },
  watch: {
    // //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    myIndex(newValue) {
      this.num = newValue
      // console.log('获得新的值' + this.num + '序列号是' + this.item.id)
    }
  },
  created() {
    this.item = this.myName
    this.num = this.myIndex
  },
  mounted() {
  },
  methods: {
    changeSelect() {
      // 触发父组件事件
      this.$emit('handleChange', this.item)
      console.log('子组件事件点击')
    }
  }
}
</script>

<style lang="scss" scoped>
.myBox {
  width: 150px;
  height: 120px;
  color: #757474;
  background: #f6f7f8;
  border-radius: 15px;
  border-style: solid;
  border-color: #eaebec;
  padding: 7px;

  text-align: center;
}
.myBox:hover{
  border-color: #c2c3c4;
  cursor:pointer;
}
.spa{
  color: #1f1f1f;
  font-weight: bold;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size:40px;
  color: #1f1f1f;
}
.car-active{
  background: #ffdfb0;
}
.banner{
  display: flow;
  position: relative;
  top:-25px;
  left: 0px;
  width: 90px;
  color: white;
  font-size: 15px;
  padding: 3px;

  background: #ff4d4f;
  border-radius: 2px;
}
.content{
  position: relative;
  top:-20px;
}
</style>
